import React from 'react'
import { Badge } from '@/shared/ui/Badge'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/shared/ui/Table'
import type { FinanceCustomerRiskRow } from '../services/financeReportsService'
import { formatMoneyFromCents } from '../utils/money'

type Props = {
  rows: FinanceCustomerRiskRow[]
}

function fmtDate(iso?: string | null): string {
  if (!iso) return '-'
  try { return new Date(iso).toLocaleDateString('pt-BR') } catch { return iso }
}

function riskBadge(reason?: string | null) {
  const r = String(reason || '').toLowerCase()
  if (r === 'cancel_at_period_end') return <Badge variant="soft" color="warning">Cancelando</Badge>
  if (r === 'past_due') return <Badge variant="soft" color="warning">Past due</Badge>
  if (r === 'expira_em_breve') return <Badge variant="soft" color="info">Expira em breve</Badge>
  return <Badge variant="soft" color="primary">Risco</Badge>
}

export function FinanceCustomersRiskTable({ rows }: Props) {
  if (!rows.length) return <div className="text-sm text-foreground/70">Nenhum cliente em risco encontrado.</div>

  return (
    <div className="overflow-auto">
      <Table>
        <Thead>
          <Tr>
            <Th>Cliente</Th>
            <Th>Status</Th>
            <Th>Plano</Th>
            <Th>Período atual</Th>
            <Th className="text-right">Último pagamento</Th>
            <Th>Risco</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((r) => (
            <Tr key={r.account_id}>
              <Td className="min-w-[260px]">
                <div className="font-medium">{r.account_name || r.account_id}</div>
                <div className="text-xs text-foreground/70">{r.owner_email || ''}</div>
              </Td>
              <Td className="whitespace-nowrap">{r.status || '-'}</Td>
              <Td className="min-w-[180px]">
                <div className="font-medium">{r.plan_name || r.plan_id || '-'}</div>
                <div className="text-xs text-foreground/70">{r.plan_interval ? String(r.plan_interval).toUpperCase() : ''}</div>
              </Td>
              <Td className="whitespace-nowrap">
                <div>{fmtDate(r.current_period_end)}</div>
                {r.cancel_at_period_end ? <div className="text-xs text-amber-400">cancel_at_period_end</div> : null}
              </Td>
              <Td className="text-right whitespace-nowrap">
                <div>{fmtDate(r.last_payment_at)}</div>
                <div className="text-xs text-foreground/70">
                  {formatMoneyFromCents(r.last_payment_amount_cents || 0, r.currency || 'BRL')}
                </div>
              </Td>
              <Td className="whitespace-nowrap">{riskBadge(r.risk_reason)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  )
}
